/* Recently Viewed — records the current product in localStorage and lazy-loads
   previously-viewed product cards via /products/{handle}?view=cn-card.
   Scoped Web Component, no globals, no dependencies. Hidden until it has items. */
(function () {
  if (window.customElements && customElements.get('recently-viewed')) return;

  var KEY = 'lsc_recently_viewed';
  // Must stay >= the Recently-viewed section's max "products_to_show" (12).
  var MAX_STORED = 16;

  function readList() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — fail silently */
    }
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.recently-viewed__grid');
      this.limit = parseInt(this.dataset.limit, 10) || 5;
      var current = this.dataset.currentHandle || '';

      var list = readList();
      if (current) {
        list = list.filter(function (h) { return h !== current; });
        list.unshift(current);
        if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
        writeList(list);
      }

      var self = this;
      // Fetch a couple extra so dropped/404 handles still backfill up to the limit.
      var toShow = list
        .filter(function (h) { return h && h !== current; })
        .slice(0, this.limit + 2);

      if (!toShow.length || !this.grid) return;
      this.renderCards(toShow);
    }

    renderCards(handles) {
      var self = this;
      var jobs = handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '?view=cn-card')
          .then(function (r) { return r.ok && !r.redirected ? r.text() : ''; })
          .then(function (html) {
            if (!html) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var tile = doc.querySelector('.sports-card-tile');
            return tile ? tile.outerHTML : null;
          })
          .catch(function () { return null; });
      });

      Promise.all(jobs).then(function (results) {
        var items = results.filter(Boolean).slice(0, self.limit);
        if (!items.length) return;
        self.grid.innerHTML = items
          .map(function (m) { return '<li class="category-navigator__item">' + m + '</li>'; })
          .join('');
        self.removeAttribute('hidden');
      });
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
})();
